import React, { useContext, useEffect, useState } from 'react';
import Stack from '@mui/material/Stack';
import MUIDataTable, { MUIDataTableColumnDef, MUIDataTableCustomHeadRenderer, MUIDataTableOptions, MUISortOptions } from "mui-datatables"
import { Row, Lev } from '../rows'
import Tooltip from '@mui/material/Tooltip'
import Button from '@mui/material/Button'
import { SocketContext } from '../contexts/socket';
import Divider from '@mui/material/Divider';
import ImageSearchIcon from '@mui/icons-material/ImageSearch';
import IconButton from '@mui/material/IconButton';
import DownloadIcon from '@mui/icons-material/Download';
import _ from 'lodash';
import { MAX_WIDTH } from '../App';
import { createTheme, MuiThemeProvider } from '@material-ui/core/styles';
import { useAuth } from '../contexts/AuthContext';
import { useISUContext } from '../pages/Gui/gui';

import { Container, Grid } from '@mui/material';

import { DataGrid, GridColDef, GridToolbar, GridValueGetterParams, GridFilterModel, GridRenderCellParams, GetColumnForNewFilterArgs, FilterColumnsArgs, useGridApiRef, getGridStringOperators } from '@mui/x-data-grid';

import WgetButton from './wget_button';
import { Link } from 'react-router-dom';
import axios from '../api/axios';
import { get_file } from '../api';

interface Props {
    rows: Row[]
}

interface CTProps {
    rows: Row[]
}

const getMuiTheme = () => createTheme({
    overrides: {

        MuiTableHead: {
            root: {
                backgroundColor: "#c1e1ec",
                textAlign: "left",
            }
        },
        MuiTableBody: {
            root: {
                backgroundColor: "orange",
                textAlign: "left",
            }
        },
        MuiTableRow: {
            root: {
                textAlign: "left",
                color: 'yellow'
            },
            head: {
                backgroundColor: '#434343'
            }
        }
    }
});

const array_to_row = (arr: Array<string | undefined>, columns: string[], order: number[]) => {
    const row: Partial<Row> = {}
    if (order) {
        columns.forEach((col: string, idx: number) => {
            row[col as keyof Row] = arr[order[idx]] as any
        })
    }
    else { // sometimes order is undefined for some unknown reason
        columns.forEach((col: string, idx: number) => {
            row[col as keyof Row] = arr[idx] as any
        })
    }
    return row as Row
}

const row_to_array = (rows: Row[], columns: string[]) => {
    const rowList = []
    for (let idx = 0; idx < rows.length; idx++) {
        const row = []
        for (let jdx = 0; jdx < columns.length; jdx++) {
            const col = columns[jdx] as keyof Row
            const r = rows[idx]
            row.push(r[col])
        }
        rowList.push(row)

    }
    return rowList
}

const CustomToolbar = (props: CTProps) => {
    return (
        <div className={"custom-toolbar-select"}>
        </div>
    );
}

const reorder = (arr: unknown[], index: number[], n: number) => {
    let newArr = [...Array(n)];
    // arr[idx] should be present at index[idx] index
    for (let idx = 0; idx < n; idx++) newArr[index[idx]] = arr[idx];
    return newArr
}


const DownloadButton = (dlProps: any) => {

    const [bgcolor, setBGColor] = React.useState('text' as "text" | "contained" | "outlined" | undefined)
    const { token } = useAuth();
    const isu = useISUContext();
    const socket = React.useContext(SocketContext);
    const downloadSingleFile = (event: any) => {
        const row = dlProps.row;
        const auth_row = { ...row, token }
        socket.emit('request_file', auth_row, isu.downloadFilenames)
        // setBGColor('contained')
        event?.target.classList.add('downloaded')
        // Temporary Work around to prevent issue with fixed dom element highlighting after download
        setTimeout(() => {
            event?.target.classList.remove('downloaded')
        }, 2500)
    }

    return (
        <Tooltip title="Download file" placement='right-end'>
            <Button sx={{ width: '100%', justifyContent: 'left', textAlign: 'left' }} variant={bgcolor} onClick={downloadSingleFile}>
                <DownloadIcon />
            </Button>
        </Tooltip>
    )
}


const FileTable = (props: Props) => {

    const socket = React.useContext(SocketContext);

    const columns = [
        'ofname',
        'koaid',
        'targname',
        'koaimtyp',
        'ut',
        'ra',
        'dec',
        'ingestType',
        'filename',
        'instrument',
        'semid',
        'frameno',
        'filehand'
    ]

    const columnOrder = [8, 1, 2, 3, 4, 5, 6, 7, 0, 9, 10, 11, 12]
    const orderedCols = reorder(columns, columnOrder, columns.length)



    const DownloadElem = (value: string, tableMeta: any, updateValue: any) => {

        const row = array_to_row(tableMeta.rowData,
            columns,
            tableMeta.tableState.columnOrder)

        const lev0or1 = ["0", "1"].some(el => row.ingestType.includes(el));

        return (
            <Stack divider={<Divider orientation="vertical" flexItem />} direction="row" spacing={1}>
                <DownloadButton row={row as Row} value={value}></DownloadButton>
                {/* {lev0or1 && (
                    <Tooltip title="view file">
                        <IconButton onClick={downloadViewOnlyFile}>
                            <ImageSearchIcon />
                        </IconButton>
                    </Tooltip>
                )} */}
            </Stack>
        )
    }

    const tblColumns: MUIDataTableColumnDef[] = [
        {
            name: "Download",
            options: {
                setCellProps: () => ({
                    align: "left",
                    style: { width: "50px", marginRight: '1em', maxWidth: "220px", textAlign: 'left', textOverflow: 'ellipses', overflow: 'hidden' },
                }),
                customHeadRender: (columnMeta: any, updateDirection: any) => (
                    <th onClick={() => updateDirection(8)} style={{ cursor: 'pointer' }}>
                    </th>
                ),
                customBodyRender: DownloadElem,
            }
        },
    ]


    const rows = row_to_array(props.rows, orderedCols)

    const options: MUIDataTableOptions = {
        filterType: 'dropdown',
        fixedHeader: true,
        columnOrder: columnOrder,
        tableBodyHeight: '500px',
        tableBodyMaxHeight: '70vh',
        onRowsDelete: () => false,
        rowsPerPage: 100,
        selectableRowsHeader: true,
        viewColumns: true,
        // viewColumns: false, //must be false
        customToolbar: () => (
            <CustomToolbar
                rows={props.rows}
            />
        ),
        selectableRows: 'none',
        setRowProps: (row, dataIndex, rowIndex) => {
            return {
                style: { padding: '0px' },
            };
        },
        setTableProps: () => {
            return {
                padding: 'none',
            };
        },
        sort: true,
        sortOrder: { name: 'UT', direction: 'desc' },
    }

    return (
        <MuiThemeProvider theme={getMuiTheme()}>
            <DataTable data={props.rows} />
        </MuiThemeProvider>
    )
}


//const downloadClkHandle = (dlProps: any) => {
const DownloadButtonT = (dlProps: any) => {

    const [bgcolor, setBGColor] = React.useState('text' as "text" | "contained" | "outlined" | undefined)
    const { token } = useAuth();
    const isu = useISUContext();
    const socket = React.useContext(SocketContext);
    const downloadSingleFile = (event: any) => {
        const row = dlProps.row;
        const auth_row = { ...row, token }
        console.log(auth_row)
        socket.emit('request_file', auth_row, isu.downloadFilenames)
        // setBGColor('contained')
        event?.target.classList.add('downloaded')
        // Temporary Work around to prevent issue with fixed dom element highlighting after download
        setTimeout(() => {
            event?.target.classList.remove('downloaded')
        }, 2500)
    }

    return (
        <Tooltip title="Download file" placement='right-end'>
            <Button sx={{ width: '4em', justifyContent: 'left', textAlign: 'left' }} variant={bgcolor} onClick={downloadSingleFile}>
                <DownloadIcon />
            </Button>
        </Tooltip>
    )
}


const koaidColDisplay = (params: GridRenderCellParams) => {
    return <><DownloadButtonT row={params.row as Row} value={params.row} /></>
}

const columns: GridColDef[] = [
    {
        field: 'filehand',
        headerName: 'Download',
        renderCell: koaidColDisplay,
        minWidth: 15,
        filterable: false,
    },
    {
        field: 'ut',
        headerName: 'UT',
        minWidth: 110,
        filterOperators: getGridStringOperators().filter(
            (operator) => operator.value === 'isEmpty' || operator.value === 'isNotEmpty' || operator.value === 'startsWith' || operator.value === 'equals',
        ),
    },
    {
        field: 'koaid',
        headerName: 'KOAID',
        minWidth: 250,
    },
    {
        field: 'ofname',
        headerName: 'Original Filename',
        minWidth: 200,
    },
    {
        field: 'targname',
        headerName: 'Target',
        minWidth: 200,
    },
    {
        field: 'koaimtyp',
        headerName: 'Image Type',
        minWidth: 100,
    },
    {
        field: 'ra',
        headerName: 'RA',
        minWidth: 120,
        filterOperators: getGridStringOperators().filter(
            (operator) => operator.value === 'isEmpty' || operator.value === 'isNotEmpty' || operator.value === 'startsWith' || operator.value === 'equals',
        ),
    },
    {
        field: 'dec',
        headerName: 'DEC',
        minWidth: 120,
        filterOperators: getGridStringOperators().filter(
            (operator) => operator.value === 'isEmpty' || operator.value === 'isNotEmpty' || operator.value === 'startsWith' || operator.value === 'equals',
        ),
    },
    {
        field: 'ingestType',
        headerName: 'Ingest Type',
        minWidth: 100,
    },
    {
        field: 'instrument',
        headerName: 'Instrument',
        minWidth: 200,
        headerClassName: 'filetable__header',
    },
    {
        field: 'filehand',
        headerName: 'Filehand',
        minWidth: 200,
        headerClassName: 'filetable__header',
    },
]



export function DataTable(data: any) {
    const _rows = data.data
    const [queryOptions, setQueryOptions] = React.useState({});
    const [loading, setLoading] = useState(true); //_rows.length;
    const [emptyTable, setEmptyTable] = useState(true); //_rows.length;

    const apiRef = useGridApiRef();
    const { token, watchDate } = useAuth();
    const isu = useISUContext();

    useEffect(() => {
        if (_rows.length > 0) {
            setLoading(false);
        }
    }, [data.data])
    const getTogglableColumns = (columns: GridColDef[]) => {
        // hide the column with field `id` from list of togglable columns
        return columns
            .filter((column) => column.field !== 'id')
            .map((column) => column.field);
    };

    const onFilterChange = React.useCallback((filterModel: GridFilterModel) => {
        // Here you save the data you need from the filter model
        setQueryOptions({ filterModel: { ...filterModel } });
        setQueryOptions(filterModel);
    }, []);

    const onFileRowChange = React.useCallback((data_: any) => {
    }, []);

    const filterColumns = ({ field, columns, currentFilters }: FilterColumnsArgs) => {
        // remove already filtered fields from list of columns
        const filteredFields = currentFilters?.map((item) => item.field);
        return columns
            .filter(
                (colDef) =>
                    colDef.filterable &&
                    (colDef.field === field || !filteredFields.includes(colDef.field)),
            )
            .map((column) => column.field);
    };

    const getColumnForNewFilter = ({
        currentFilters,
        columns,
    }: GetColumnForNewFilterArgs) => {
        const filteredFields = currentFilters?.map(({ field }) => field);
        const columnForNewFilter = columns
            .filter(
                (colDef) => colDef.filterable && !filteredFields.includes(colDef.field),
            )
            .find((colDef) => colDef.filterOperators?.length);
        return columnForNewFilter?.field ?? null;
    };

    const handleFilterModelChange = ((f_row: any) => {
        //onFilterModelChange={handleFilterModelChange}
        return f_row
    });


    const socket = React.useContext(SocketContext);
    const tblColumns_ = [
        "filename",
        "ut",
        "Koaid",
        "ofname",
        "targname",
        "ra",
        "dec",
        "ingestType",
        "instrument",
        "semid",
        "koaimtyp",
        "filename",
    ]

    // Precise order of Table Columns
    // Also used in generating the filter list sent with the Wget request.
    const column_ordered = ['filename', 'filename', 'ut', 'Koaid', 'ofname', 'targname', 'ra', 'dec', 'ingestType', 'instrument', 'semid', 'koaimtyp', 'filehand', 'propint']

    const tblColumns: MUIDataTableColumnDef[] = [
        {
            name: "filename",
            label: "File Descriptor",
            options: {
                filter: true,
                filterType: 'textField',
                customBodyRender: (value, tableMeta, updateValue) => {
                    const download_button_hdl = (ev:any) => {
                        // const get_link = `/get_file&p=${value}`;
                        const get_link = `${watchDate.replaceAll('-', '')}_${value}`;
                        const row_ = tableMeta.rowData;
                        const row_wkey = Object.fromEntries(
                           column_ordered.map((x:string, y) => [x, row_[y]])
                        )                        
                        console.log('TblCol, row_, row_wkey, col_ordered')
                        // Trigger get file event and on listener run get_file
                        const auth_row = { ...row_wkey, token };
                        socket.emit('request_file', auth_row, isu.downloadFilenames)
                    }
                    return (
                        <Button onClick={download_button_hdl} color='primary'>
                            <DownloadIcon></DownloadIcon>
                        </Button>
                    );
                },
            }
        },
        {
            name: "filename",
            label: " ",
            options: {
                filter: true,
                filterType: 'textField',
                customBodyRender: (value, tableMeta, updateValue) => {
                    return (<p>{value}</p>);
                },
            }
        },
        {
            name: "ut",
            label: "UT",
            options: {
                filter: true,
                filterType: 'textField',
            }
        },
        {
            name: "Koaid",
            label: "koaid",
            options: {
                filter: true,
                filterType: 'textField'
            }
        },
        {
            name: "ofname",
            label: "Original Filename",
            options: {
                filter: true,
                filterType: 'textField'
            }
        },
        {
            name: "targname",
            label: "Target",
            options: {
                filter: true,
                filterType: 'dropdown'
            }
        },
        {
            name: "ra",
            label: "RA",
            options: {
                filter: true,
                filterType: 'textField'
            }
        },
        {
            name: "dec",
            label: "DEC",
            options: {
                filter: true,
                filterType: 'textField'
            }
        },
        {
            name: "ingestType",
            label: "Ingestion Type",
            options: {
                filter: true,
                filterType: 'dropdown'
            }
        },
        {
            name: "instrument",
            label: "Instrument",
            options: {
                filter: true,
                filterType: 'dropdown'
            }
        },
        {
            name: "semid",
            label: "SEMID",
            options: {
                filter: true,
                filterType: 'dropdown'
            }
        },
        {
            name: "koaimtyp",
            options: {
                filter: true,
                filterType: 'dropdown',
                display: true
            }
        },
        {
            name: "filehand",
            options: {
                filter: false,
                filterType: 'dropdown',
                display: false
            }
        },
        {
            name: "propint",
            options: {
                filter: false,
                filterType: 'dropdown',
                display: false
            }
        },
    ]

    const buildFilterModel = (filterArray: any) => {
        console.log(filterArray);
        const items: { field: any; operator: string; value: any; }[] = []

        filterArray.forEach((x:any , element: any) => {
            const field = column_ordered[element];
            console.log(x)
            if ( x && filterArray[element].join(',') != "") {
                items.push({ 'field': field, 'operator' : ('contains'), 'value': filterArray[element].join(',') })
            }
        });
    
        console.warn({items});
        return {items};
    }
    
    const odapToolbar = () => {
        return (
             <span>
                    <WgetButton filterModel={queryOptions} loading={loading} disabled={_rows.length <= 0 || emptyTable == true} />
             </span>)
    }

    return (
        <div style={{ height: 600, width: '100%' }} className="no-print ui_file_table">
            <MUIDataTable
                title={"Ingestion Table"}
                data={_rows}
                columns={tblColumns}
                options={{ 
                    "selectableRows": "none",
                    "sortOrder": {name: 'ut', direction: "asc"},
                    "onTableChange": ( (n,y) => { console.log(n); console.log(y);  console.log(`**Table has changed!! ${_rows.length} - ${y.data.length}`); 
                        if (y.data.length > 0) {
                            setEmptyTable(false);   
                        }
                    }),
                    "customToolbar": (odapToolbar),
                    "onFilterChange": ((x, y, a, b, c) => {
                        setQueryOptions( buildFilterModel( y ) )
                    })
                }}
            />
            <div style={{height: '20em', width: '100%'}}></div>
        </div>
    );
}

export default FileTable 
